import React from 'react';
import SnippetCard from './SnippetCard';
import { FileText, Search } from 'lucide-react';

const SnippetList = ({ snippets, onEditSnippet, onDeleteSnippet, searchQuery }) => {
  if (snippets.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-4">
          {searchQuery ? (
            <Search className="w-8 h-8 text-gray-400" />
          ) : (
            <FileText className="w-8 h-8 text-gray-400" />
          )}
        </div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
          {searchQuery ? 'No snippets found' : 'No snippets yet'}
        </h3>
        <p className="text-gray-500 dark:text-gray-400 max-w-md mx-auto">
          {searchQuery 
            ? `No snippets match "${searchQuery}". Try different keywords or create a new snippet.`
            : 'Create your first snippet to get started. Click the "New Snippet" button above.'
          }
        </p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-medium text-gray-900 dark:text-white">
          {searchQuery ? `Search results for "${searchQuery}"` : 'Your Snippets'}
        </h2>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {snippets.length} snippet{snippets.length !== 1 ? 's' : ''}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {snippets.map((snippet) => (
          <SnippetCard
            key={snippet.id}
            snippet={snippet}
            onEdit={onEditSnippet}
            onDelete={onDeleteSnippet}
          />
        ))}
      </div>
    </div>
  );
};

export default SnippetList;
